import { render, staticRenderFns } from "./IngredientsTable.vue?vue&type=template&id=4b870444&scoped=true&lang=pug&"
import script from "./IngredientsTable.vue?vue&type=script&lang=js&"
export * from "./IngredientsTable.vue?vue&type=script&lang=js&"
import style0 from "./IngredientsTable.vue?vue&type=style&index=0&id=4b870444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b870444",
  null
  
)

export default component.exports